import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    FunctionField,
    Button,
    EditButton,
    TopToolbar,
    DeleteButton,
    useTranslate,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ShowActions = () => (
    <TopToolbar>
        <Button label="Hallinta" component={Link} to="/hallinta?tab=3">
            <ArrowBackIcon />
        </Button>
        <EditButton />
        <DeleteButton />
    </TopToolbar>
);

const SecretValueField = () => {
    const translate = useTranslate();
    return (
        <FunctionField
            label={translate('resources.secrets.fields.secretString')}
            render={(record: any) => {
                if (!record?.secretString) return null;
                let formatted = record.secretString;
                try {
                    const parsed = JSON.parse(record.secretString);
                    formatted = JSON.stringify(parsed, null, 2);
                } catch {
                    // not JSON, use as-is
                }
                return (
                    <Box
                        component="pre"
                        sx={{
                            bgcolor: 'grey.100',
                            p: 2,
                            borderRadius: 1,
                            overflow: 'auto',
                            maxHeight: 400,
                            fontSize: '0.8rem',
                            fontFamily: 'monospace',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all',
                        }}
                    >
                        {formatted}
                    </Box>
                );
            }}
        />
    );
};

const TagsField = () => {
    const translate = useTranslate();
    return (
        <FunctionField
            label={translate('resources.secrets.fields.tags')}
            render={(record: any) => {
                if (!record?.tags || record.tags.length === 0) return null;
                return (
                    <Box>
                        {record.tags.map(
                            (
                                tag: {
                                    Key?: string;
                                    key?: string;
                                    Value?: string;
                                    value?: string;
                                },
                                i: number
                            ) => (
                                <Typography key={i} variant="body2">
                                    <strong>{tag.Key || tag.key}</strong>:{' '}
                                    {tag.Value || tag.value}
                                </Typography>
                            )
                        )}
                    </Box>
                );
            }}
        />
    );
};

const SecretsShow = () => (
    <Show
        actions={<ShowActions />}
        queryOptions={{ refetchOnMount: 'always', staleTime: 0 }}
    >
        <SimpleShowLayout>
            <TextField source="name" />
            <TextField source="description" />
            <SecretValueField />
            <DateField source="createdDate" showTime locales="fi-FI" />
            <DateField source="lastChangedDate" showTime locales="fi-FI" />
            <DateField
                source="lastAccessedDate"
                showTime={false}
                locales="fi-FI"
            />
            <TextField source="versionId" />
            <TagsField />
        </SimpleShowLayout>
    </Show>
);

export default SecretsShow;
